import { render, staticRenderFns } from "./AddToFriendsForm.vue?vue&type=template&id=557f97f2&scoped=true&"
import script from "./AddToFriendsForm.vue?vue&type=script&lang=js&"
export * from "./AddToFriendsForm.vue?vue&type=script&lang=js&"
import style0 from "./AddToFriendsForm.vue?vue&type=style&index=0&id=557f97f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557f97f2",
  null
  
)

export default component.exports